import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

// created/last_login come back as Unix seconds (PHP time()), not JS ms.
export const formatRelativeTime = (value) => (value ? dayjs(value * 1000).fromNow() : null);
